export abstract class GeneralMessages { // class interface https://angular.io/guide/dependency-injection-in-action#class-interface
  abstract error(title: string, message: string, ...args): void;
  abstract info(title: string, message: string, ...args): void;
  abstract warning(title: string, message: string, ...args): void;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/general-messages-generic.service.ts